import {useState} from "react";
import {Button, HStack} from "@chakra-ui/react";
import T from "platformed-components/i18n/T";
import {logout} from "../../api/auth";
import {usePromiseState} from "../../hooks/promiseState";
import {withDialog} from "../../state/withDialog";
import {Checkbox} from "../../components/ui/checkbox";
import {DialogBody, DialogFooter, DialogHeader, DialogTitle} from "../../components/ui/dialog";

const SignOutDialog = withDialog(({onClose}: {onClose: () => void}) => {
  const [allDevices, setAllDevices] = useState(false);
  const [signingOut, signOut] = usePromiseState(async () => {
    await logout({allDevices});
    onClose();
  }, [allDevices, onClose]);
  return (
    <>
      <DialogHeader>
        <DialogTitle>
          <T keyName="c.Sign_out" />
        </DialogTitle>
      </DialogHeader>
      <DialogBody>
        <Checkbox checked={allDevices} onCheckedChange={d => setAllDevices(d.checked === true)} colorPalette="blue">
          <T keyName="c.Sign_out_of_all_devices" />
        </Checkbox>
      </DialogBody>
      <DialogFooter>
        <HStack gap="3">
          <Button variant="ghost" onClick={onClose}>
            <T keyName="c.Cancel" />
          </Button>
          <Button colorPalette="blue" onClick={signOut} loading={signingOut.inProgress}>
            <T keyName="c.Sign_out" />
          </Button>
        </HStack>
      </DialogFooter>
    </>
  );
});

export default SignOutDialog;
